import React from 'react';
import DetailAccordion from 'pages/product-detail/DetailAccordion';
import { Container, Heading } from 'styles/pages/product-detail/detail';

const Section = ({ data, onColorSelect, onImageSelect }) => (
  <Container>
    <Heading>{data?.Product?.Name}</Heading>
    <DetailAccordion
      data={data}
      onColorSelect={onColorSelect}
      onImageSelect={onImageSelect}
    />
  </Container>
);

export default Section;
